<div class="my-sent-container">
  <div class="my-sent-header">
    <h2>{{ 'sidebar.mySent' | translate }}</h2>
  </div>

  <app-common-grid
    [rows]="(requests$ | async) || []"
    [columns]="columns"
    [actions]="actions"
    [loading]="(loading$ | async) || false"
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalRecords]="(totalRecords$ | async) || 0"
    [pageSizeOptions]="pageSizeOptions"
    [showPagination]="true"
    [enableRowClick]="true"
    rowIdentifier="id"
    emptyStateMessageKey="requests.noRequests"
    (actionTriggered)="onTableAction($event)"
    (rowClick)="onRowClick($event)"
    (pageChange)="loadPage($event)"
    (pageSizeChange)="changePageSize($event)"
  ></app-common-grid>
